import React, { useState } from 'react';
import { useDemo } from '../providers/DemoProvider';
import { PACKS } from '../../../data/packs';
import DemoSidebar from './DemoSidebar';
import './DemoSidebar.css'; // Import the new, scoped CSS
import { Link } from 'react-router-dom';
import LockedFeatureModal from '../components/LockedFeatureModal';

const DemoShell: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const { wallet, equippedMuseId, showLockedModal } = useDemo();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const allMuses = Object.values(PACKS).flatMap(p => p.muses);
  const equippedMuse = allMuses.find(m => m.name === equippedMuseId);

  return (
    <div className="layout demo-shell">
      <Link 
        to="/" 
        className="back-to-login-button"
        style={{
          position: 'fixed',
          top: '20px',
          left: '20px',
          zIndex: 1003,
          background: 'rgba(255, 255, 255, 0.9)',
          color: '#111',
          padding: '8px 16px',
          borderRadius: '20px',
          textDecoration: 'none',
          fontWeight: 700,
          boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
        }}
      >
        ← Back to Login
      </Link>
      <button
        className="hamburger-menu"
        onClick={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
      >
        <div style={{ transform: isMobileSidebarOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none' }} />
        <div style={{ opacity: isMobileSidebarOpen ? 0 : 1 }} />
        <div style={{ transform: isMobileSidebarOpen ? 'rotate(-45deg) translate(7px, -6px)' : 'none' }} />
      </button>
      <div 
        className="sidebar-container" 
        style={{ transform: isMobileSidebarOpen ? 'translateX(0)' : 'translateX(-100%)' }}
      >
        <DemoSidebar />
      </div>
      <main className="page-content">
        <div style={{ position: 'fixed', top: '20px', right: '40px', zIndex: 1001, display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', background: 'rgba(255,255,255,0.9)', padding: '8px 16px', borderRadius: '20px', color: '#111', fontWeight: 700, boxShadow: '0 4px 15px rgba(0,0,0,0.1)' }}>
            <span>💰 {wallet.balance}</span>
            {equippedMuse && <img src={equippedMuse.img} alt={equippedMuse.name} style={{ width: '32px', height: '32px', borderRadius: '50%' }} />}
          </div>
           <button onClick={showLockedModal} style={{ display: 'inline-block', padding: '0.6rem 1rem', background: 'linear-gradient(135deg, #4FC3F7, #29B6F6)', color: '#fff', borderRadius: '1rem', textDecoration: 'none', fontWeight: 700, fontSize: '0.9rem', boxShadow: '0 4px 15px rgba(79,195,247,0.3)', border: 'none', cursor: 'pointer' }}>Unlock Full Access</button>
        </div>
        <div style={{ paddingTop: '80px' }}> {/* Add padding to push content below the fixed header elements */}
          <LockedFeatureModal />
          {children}
        </div>
      </main>
    </div>
  );
};

export default DemoShell;


